import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	IPageDidUnmountHandler,
	PageFeatureConfigSymbol,
	SiteFeatureConfigSymbol,
	contextIdSymbol,
} from '@wix/thunderbolt-symbols'
import { name, ExternalComponentCssManagerSymbol } from './symbols'
import type { IExternalComponentCssManager } from './types'
import { ExternalComponentPageConfig, ExternalComponentSiteConfig } from './types'

export const ExternalComponentPageDidUnmount = withDependencies(
	[
		named(PageFeatureConfigSymbol, name),
		named(SiteFeatureConfigSymbol, name),
		ExternalComponentCssManagerSymbol,
		contextIdSymbol,
	],
	(
		pageConfig: ExternalComponentPageConfig,
		{ disableBYOC }: ExternalComponentSiteConfig,
		externalComponentCssManager: IExternalComponentCssManager,
		contextId: string
	): IPageDidUnmountHandler => {
		const cssUrls = pageConfig.urlsToFetchCss

		return {
			async pageDidUnmount() {
				if (disableBYOC) {
					return
				}
				cssUrls.forEach((url) => externalComponentCssManager.release(contextId, url))
			},
		}
	}
)
